import { Box, Button, Typography } from '@mui/material';
import * as React from 'react';
import { useDropzone } from 'react-dropzone';

import { UploadIcon } from '../../components/actionIcons';
import FileActionRow from '../../components/FileActionRow';
import { url2filename } from '../../utils';

const fileName = (file) => {
    if (typeof File !== 'undefined' && file instanceof File) {
        return file.name;
    }
    const name = url2filename((typeof file === 'string' ? file : file.file) || '').split('?')[0];
    try {
        return decodeURIComponent(name);
    } catch (e) {
        return name;
    }
};

// CP-5559 (Martina's approved KML UI, shared by Trip Info and Itinerary days): a "KML" heading, then
// [UPLOAD KML FILE] until there is a file, then the file row: name (downloads; ellipsis + tooltip when long),
// blue Replace, red trash. Without write access both stay visible but disabled (CP-5545/CP-5556).
const UploadKMLFileButton = (props) => {
    const { file, disabled, label, accept, onSelect } = props;

    const dz = useDropzone({
        noClick: true,
        noKeyboard: true,
        maxFiles: 1,
        onDrop: (acceptedFiles) => onSelect && acceptedFiles[0] && onSelect(acceptedFiles[0]),
        accept,
        multiple: false,
    });

    return (
        <Box>
            <input {...dz.getInputProps()} />
            <Typography fontWeight="bold" sx={{ mb: 0.5 }}>
                KML
            </Typography>
            {file ? (
                <FileActionRow
                    name={label || fileName(file)}
                    file={file}
                    onReplace={dz.open}
                    onDelete={() => onSelect && onSelect(null, file)}
                    replaceTitle="Replace KML file"
                    deleteTitle="Remove KML file"
                    disabled={disabled}
                />
            ) : (
                <Button variant="outlined" color="primary" startIcon={<UploadIcon />} disabled={disabled} onClick={dz.open}>
                    Upload KML file
                </Button>
            )}
        </Box>
    );
};

export default React.memo(UploadKMLFileButton);
